import React from 'react';
import styled from 'styled-components';

export function Schedule() {
  return <Header>Schedule</Header>;
}

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 30px;
`;
